/**
 * Additive PDP helpers for the charcoal / chooser sections.
 * Dawn's product-info.js updates price and the ATC button on variant
 * change but does not swap a custom mat image or the waitlist/ATC slot.
 * We copy those nodes from the section HTML it already fetched.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function swapBySelector(root, html, selector) {
    var dest = root.querySelector(selector);
    var src = html.querySelector(selector);
    if (!dest || !src) return;
    dest.replaceWith(src.cloneNode(true));
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var html = event.data && event.data.html;
    var sectionId = event.data && event.data.sectionId;
    if (!html || !sectionId) return;

    var root = document.querySelector('#MainProduct-' + sectionId);
    if (!root) return;

    swapBySelector(root, html, '[data-sj-pdp-mat]');
    swapBySelector(root, html, '[data-sj-pdp-buy]');
    swapBySelector(root, html, '[data-sj-pdp-name]');
    swapBySelector(root, html, '[data-sj-pdp-caption]');
  });
})();
